  import React from 'react';
import { RadioGroup } from '@tencent/spaui';

const StrategyRadio = (props) => {
  const selectedMap = props.strategyMap;
  const data = selectedMap.map((ele) => ({
    value: ele.key,
    children: ele.title,
    addon: ele.desc,
  }));

  return <RadioGroup vertical data={data} value={props.value} onChange={props.onChange} />;
};

export default StrategyRadio;
